// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__4kG1v","Main":"Layout_Main__jlFtd","Content":"Layout_Content__gynaM","Sidebar":"Layout_Sidebar__YaM6T","subContent":"Layout_subContent__gMIWx"};